import script from "./PopularArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularArticle.vue?vue&type=script&setup=true&lang=js"

import "./PopularArticle.vue?vue&type=style&index=0&id=5197ac9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5197ac9b"]])

export default __exports__